import jwtDecode from 'jwt-decode';
import differenceInDays from 'date-fns/differenceInDays';
import { refreshToken } from '../auth/auth';
export const checkTokenStatus = async () => {
    const token = localStorage.getItem('authToken');
    try {
        if (token) {
            const decodedToken = jwtDecode(token);
            const tokenExpiry = decodedToken.exp;
            const date = new Date();
            const diffInDays = differenceInDays(tokenExpiry * 1000, date.getTime());
            if (diffInDays > 0 && diffInDays <= 2) {
                const { status, data, error } = await refreshToken();
                if (status === 'ok' && data !== null) {
                    localStorage.setItem('authToken', data);
                }
                if (error) {
                    throw Error('Refresh Token API error');
                }
            }
        }
    }
    catch (error) {
        console.error(error);
    }
};
//# sourceMappingURL=refreshToken.js.map